import { render } from "./OrderDataStatsGrid.vue?vue&type=template&id=27e2df7a&scoped=true&ts=true"
import script from "./OrderDataStatsGrid.vue?vue&type=script&lang=ts"
export * from "./OrderDataStatsGrid.vue?vue&type=script&lang=ts"

import "./OrderDataStatsGrid.vue?vue&type=style&index=0&id=27e2df7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e2df7a"]])

export default __exports__